import styled from 'styled-components';
import { Button, Typography, Collapse } from 'antd';

const { Text } = Typography;

export const CollapsContainer = styled(Collapse)`
  .ant-collapse-item,
  .site-collapse-custom-panel {
    margin-bottom: 30px;
    background-color: #f7f8f9;
    filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.16));
    overflow: hidden;
    border-radius: 8px;

    .ant-collapse-header {
      padding: 17px 26px 17px 28px;
      align-items: center;

      .ant-collapse-extra {
        margin-inline-start: auto;
        margin-right: 16px;
      }
    }

    .ant-collapse-content {
      .ant-collapse-content-box {
        padding: 0 26px 17px 28px;
        textarea {
          border: none;
          background-color: #fff;
        }
      }
    }
  }
`;

export const Content = styled.div`
  padding: 16px 8px 6px 0;
`;

export const Header = styled.div``;

export const BoxTitle = styled.div`
  font-size: 14px;
`;

export const Title = styled(Text)`
  font-size: 14px;
  line-height: 22px;
  margin: 0;
  padding: 0;
  font-weight: bold;
  color: ${props => props.color || '#828282'};
`;

export const BoxSubTitle = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
`;

export const TextDivergencia = styled(Text)`
  font-size: 14px;
  color: #d42929;
`;

export const Buttom = styled(Button)`
  border-radius: 0;
  border: none;
  color: #fff;
  padding: 0;
`;

export const TitleContent = styled(Text)`
  font-size: 14px;
  color: ${props => (props.red ? '#D42929' : '#707070')};
  font-weight: ${props => (props.weight ? 'bold' : 'nomal')};
`;

export const SpaceCusto = styled.div`
  .openCollaps {
    transform: rotate(0deg);
    transition: transform 400ms ease-in-out;
    cursor: pointer;
  }
  .openCollaps.active {
    transform: rotate(180deg);
    transition: transform 400ms ease-in-out;
    cursor: pointer;
  }
`;
